import React from 'react';
import { useDispatch } from 'react-redux';
import Guide from '../../../../../components/Common/Guide';
import { setStoryData } from '../../../../../store/storySlice';
import { CONFIG } from '../../../../../config/mainConfig';
import { setCurrentStep } from '../../../../../store/appSlice';
import { UserLocalStorageKeysEnum, UserModel } from '../../../../../interfaces/user.interface';
import { BookModel } from '../../../../../interfaces/book.interface';
import { Loaders } from '../../../../../interfaces/common.interface';

interface CharacterIllustrationHeaderProps {
  user: UserModel;
  storyData: BookModel;
  loaders: Loaders;
  setLoaders: React.Dispatch<React.SetStateAction<Loaders>>;
  setLibrary: React.Dispatch<React.SetStateAction<any>>;
  characterMatchingLibrary: any[];
  setShowCharacterLibrary: React.Dispatch<React.SetStateAction<boolean>>;
  getCharacterLibary: (
    email: string,
    loaders: Loaders,
    setLoaders: React.Dispatch<React.SetStateAction<Loaders>>,
    setLibrary: React.Dispatch<React.SetStateAction<any>>,
  ) => void;
  setCurrentStoryStep: (step: any) => void;
  currentStep: number;
  imageUploading: boolean;
  draftId: string | null;
  onBack?: (navigateBack: () => void) => void;
  isOnTour?: boolean;
}

const CharacterIllustrationHeader: React.FC<CharacterIllustrationHeaderProps> = ({
  user,
  storyData,
  loaders,
  setLoaders,
  setLibrary,
  characterMatchingLibrary,
  setShowCharacterLibrary,
  getCharacterLibary,
  setCurrentStoryStep,
  currentStep,
  imageUploading,
  draftId,
  onBack,
  isOnTour,
}) => {
  const dispatch = useDispatch();

  const handleCharacterLib = () => {
    setShowCharacterLibrary(true);

    dispatch(
      setStoryData({
        ...storyData,
        showLibrary: true,
      }),
    );
    getCharacterLibary(user?.email!, loaders, setLoaders, setLibrary);
  };

  const doNavigateBack = () => {
    const isEditMode = localStorage.getItem(UserLocalStorageKeysEnum.EDIT_MODE);
    const setEditMode = isEditMode ? true : false;

    const pagesData = Object.values(storyData?.illustrationCharacter || {});
    const isPageImageGeneration = !!storyData?.illustrationCharacter?.hasOwnProperty('pageIndex');
    if (
      (!setEditMode && !storyData?.illustrationCharacter?.pageIndex) ||
      ((pagesData.length === 0 || pagesData.every((item) => !item.scene)) && !isPageImageGeneration)
    ) {
      dispatch(setCurrentStep(currentStep - 1));
      setCurrentStoryStep(CONFIG.STORY_STEPS.BASIC_INFO);
    } else if (storyData?.illustrationCharacter && isPageImageGeneration) {
      dispatch(setCurrentStep(3));
      setCurrentStoryStep(CONFIG.STORY_STEPS.ILLUSTRATION_CREATE);
    }
  };

  const handleBackCharacterLib = () => {
    if (onBack) {
      onBack(doNavigateBack);
    } else {
      doNavigateBack();
    }
  };

  return (
    <div className="w-full flex justify-between flex-wrap gap-2 items-center">
      <div className=" flex items-center align-end">
        <h2 className="text-left text-xl md:text-4xl font-bold text-storyblue">Build My Character</h2>
        <div>
          <Guide />
        </div>
      </div>
      <div className="flex gap-2 flex-wrap md:flex-nowrap">
        {characterMatchingLibrary?.length > 0 && !isOnTour && (
          <button
            onClick={() => handleCharacterLib()}
            className="bg-storyblueSecondLightText text-white font-bold rounded-2xl px-4 py-2 text-sm "
            disabled={loaders?.characterGenerating || loaders?.characterRegenerate}
          >
            Character Library
          </button>
        )}
        {!isOnTour && (
          <button
            id="step-back-button"
            className="bg-storyblueSecondLightText text-white font-bold rounded-2xl px-4 py-2 text-sm "
            onClick={() => handleBackCharacterLib()}
            disabled={imageUploading || loaders?.characterGenerating || loaders?.characterRegenerate}
          >
            Back
          </button>
        )}
      </div>
    </div>
  );
};

export default CharacterIllustrationHeader;
